module.exports = __webpack_public_path__ + "static/media/default.0438f9b2.png";